import { render, staticRenderFns } from "./MarketplaceSection.vue?vue&type=template&id=38aea5d4&"
import script from "./MarketplaceSection.vue?vue&type=script&lang=js&"
export * from "./MarketplaceSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports